<template><section><h4>Vant 在企业微信得使用</h4>
<h5>1、添加代码（方式四. 通过 CDN 引入）</h5>
<h6>使用 Vant 最简单的方法是直接在 html 文件中引入 CDN 链接，之后你可以通过全局变量vant访问到所有组件。</h6>
<pre v-pre><code v-pre>```
 &lt;link rel=&quot;stylesheet&quot; href=&quot;https://cdn.jsdelivr.net/npm/vant@2.4/lib/index.css&quot;&gt;
</code></pre>
<pre v-pre><code v-pre>&lt;!-- 引入 Vue 和 Vant 的 JS 文件 --&gt;
&lt;script src=&quot;https://cdn.jsdelivr.net/npm/vue/dist/vue.min.js&quot;&gt;&lt;/script&gt;
&lt;script src=&quot;https://cdn.jsdelivr.net/npm/vant@2.4/lib/vant.min.js&quot;&gt;&lt;/script&gt;
&lt;script&gt;
  // 在 #app 标签下渲染一个按钮组件
  new Vue({
    el: '#app',
    template: `&lt;van-button&gt;按钮&lt;/van-button&gt;`
  });
  // 调用函数组件，弹出一个 Toast
vant.Toast('提示');
&lt;/script&gt;
</code></pre>
<p>这是有赞官网<a href="https://youzan.github.io/vant/#/zh-CN/quickstart" title="Vant官网">Vant官网</a>.</p>
<template>
</template>


</section></template>
<style>
  .card{
    margin:auto;
    width: 600px;
    text-align: center;
  }
</style>
<script>
// @ is an alias to /src


export default {
  name: 'Home',
  components: {
    
  },
  methods:{
      clickFn(){
          alert('aa')
      }
  }
}
</script>